import { Link } from '@mui/material';
import createHighlightedParts from './highlightUtils';
import { withDefaultScheme } from './linkUrlUtils';

const renderMarkdownParts = (
  parts: any[],
  searchQuery?: string
): React.ReactNode[] => {
  return parts.map((part, index) => {
    if (part.type === 'link') {
      return (
        <Link
          key={index}
          href={withDefaultScheme(part.url)}
          target='_blank'
          rel='noopener nofollow'
          onClick={(e) => e.stopPropagation()}
          sx={{
            fontWeight: 'normal',
            textDecoration: 'none',
            color: '#009389',
            '&:hover': { textDecoration: 'underline' }
          }}
        >
          {Array.isArray(part.text)
            ? renderMarkdownParts(part.text, searchQuery)
            : createHighlightedParts(part.text || '', searchQuery)}
        </Link>
      );
    }
    if (part.type === 'bold') {
      return (
        <strong key={index}>
          {createHighlightedParts(part.content || '', searchQuery)}
        </strong>
      );
    }
    if (part.type === 'italic') {
      return (
        <em key={index}>
          {createHighlightedParts(part.content || '', searchQuery)}
        </em>
      );
    }
    if (part.type === 'text') {
      return createHighlightedParts(part.content || '', searchQuery);
    }
    return createHighlightedParts(
      typeof part === 'string' ? part : part.content || '',
      searchQuery
    );
  });
};

export default renderMarkdownParts;
